import React from "react";
import clsx from "clsx";
import ReactHTMLPicture from "@micado-digital/react-htmlpicture/ReactHTMLPicture";

import styles from "./Item.styles";

const Teasergroup2columnsItem = ({ linkvalue, linkdisplay, itemImage }) => {
	const css = styles();
	const { REACT_APP_PATH } = process.env

	return (
		<>
			{linkvalue &&
				<a href={linkvalue} target="_blank" rel="noreferrer" className={clsx(css.item, "mco-extension-component-teasergroup2columns__item")}>
					<p className={clsx(css.link, "mco-extension-component-teasergroup2columns__link")}>{linkdisplay}</p>
					<ReactHTMLPicture
						alt={linkdisplay}
						media={itemImage}
						mediaFormats={{
							xs: "teasergroup2columns"
						}}
						path={REACT_APP_PATH}
						webpFallback={true}
					/>
				</a>
			}
		</>
	);
};

export default Teasergroup2columnsItem;